module.exports = __webpack_public_path__ + "img/850ac84.jpg";